import { FC } from "react";
import { RichText } from "../../internal-components/rich-text/richText.js";

interface Props {
  title?: string;
  text?: string;
}

const Banner: FC<Props> = ({ text, title }) => {
  return (
    <div className="banner mw-small">
      <div className="content">
        {title && <h1 className="title">{title}</h1>}
        {text && <RichText html={text} />}
      </div>
    </div>
  );
};
export default Banner;
